const SENSITIVE_QUERY_PARAMS = ["ml", "tok", "t"]

/** Removes authentication tokens from absolute URLs, relative paths, and search strings. */
export function redactUrl(inputUrl = ""): string {
  const queryIndex = inputUrl.indexOf("?")
  if (queryIndex < 0) return inputUrl

  const hashIndex = inputUrl.indexOf("#", queryIndex)
  const queryEnd = hashIndex < 0 ? inputUrl.length : hashIndex
  const search = new URLSearchParams(inputUrl.slice(queryIndex + 1, queryEnd))
  SENSITIVE_QUERY_PARAMS.forEach((param) => search.delete(param))
  const query = search.toString()
  return `${inputUrl.slice(0, queryIndex)}${query ? `?${query}` : ""}${inputUrl.slice(queryEnd)}`
}
